module.exports = __webpack_public_path__ + "static/media/es1.be38ca68.png";